import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {NgClass} from '@angular/common';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {CoverageAnalysisView} from '../rfi-coverage-analysis-dialog.types';
import {CoverageSectionComponent} from '../coverage-section/coverage-section.component';
import {CoverageNoteComponent} from '../coverage-note/coverage-note.component';
import {CoverageOptionToggleComponent} from '../coverage-option-toggle/coverage-option-toggle.component';
import {
  CoverageTableColumn,
  CoverageTableHeadComponent,
} from '../coverage-table-head/coverage-table-head.component';

const COLUMN_KEY_PREFIX = 'project.steps.rfi.invitationList.analysis.column.';

const SUBTOTAL_COLUMNS: CoverageTableColumn[] = [
  {labelKey: `${COLUMN_KEY_PREFIX}function`},
  {labelKey: `${COLUMN_KEY_PREFIX}weight`},
  {labelKey: `${COLUMN_KEY_PREFIX}employees`, numeric: true},
  {labelKey: `${COLUMN_KEY_PREFIX}possible`, numeric: true},
  {labelKey: `${COLUMN_KEY_PREFIX}achieved`, numeric: true},
  {labelKey: `${COLUMN_KEY_PREFIX}missing`, numeric: true},
];

const CALCULATION_COLUMNS: CoverageTableColumn[] = [
  {labelKey: `${COLUMN_KEY_PREFIX}function`},
  {labelKey: `${COLUMN_KEY_PREFIX}country`},
  {labelKey: `${COLUMN_KEY_PREFIX}weight`},
  {labelKey: `${COLUMN_KEY_PREFIX}employees`},
  {labelKey: `${COLUMN_KEY_PREFIX}possible`, numeric: true},
  {labelKey: `${COLUMN_KEY_PREFIX}achieved`, numeric: true},
  {labelKey: `${COLUMN_KEY_PREFIX}loss`, numeric: true},
];

@Component({
  selector: 'app-coverage-calculation-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    AppNumberPipe,
    TranslocoPipe,
    CoverageSectionComponent,
    CoverageNoteComponent,
    CoverageOptionToggleComponent,
    CoverageTableHeadComponent,
  ],
  templateUrl: './coverage-calculation-tab.component.html',
})
export class CoverageCalculationTabComponent {
  protected readonly subtotalColumns = SUBTOTAL_COLUMNS;
  protected readonly calculationColumns = CALCULATION_COLUMNS;

  readonly view = input.required<CoverageAnalysisView>();

  protected readonly onlyMissingPoints = signal(false);

  protected readonly visibleCalculationRows = computed(() => {
    const rows = this.view().calculationRows;
    return this.onlyMissingPoints() ? rows.filter((row) => !row.covered) : rows;
  });
}
